/* Sticky CTA: show after one viewport of scroll, hide while any inline CTA button is on screen. Fires dataLayer events per CTA. */
(function () {
  function init() {
    var bar = document.querySelector('.ps-sticky');
    var ctas = document.querySelectorAll('[data-ps-cta]');
    window.dataLayer = window.dataLayer || [];
    ctas.forEach(function (el) {
      el.addEventListener('click', function () {
        window.dataLayer.push({ event: 'presell_cta_click', cta_id: el.getAttribute('data-ps-cta'), cta_label: el.textContent.trim() });
      });
    });
    if (!bar) return;
    var threshold = parseFloat(bar.getAttribute('data-show-after') || '1');
    var inlineVisible = 0;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inlineVisible += e.isIntersecting ? 1 : -1; });
        inlineVisible = Math.max(0, inlineVisible);
        update();
      }, { threshold: 0.2 });
      document.querySelectorAll('.ps__btn[data-ps-cta]:not(.ps-sticky .ps__btn)').forEach(function (b) { io.observe(b); });
    }
    function update() {
      var scrolled = window.scrollY > window.innerHeight * threshold;
      var show = scrolled && inlineVisible === 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('ps-has-sticky', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
